import React from "react";
import PropTypes from "prop-types";

import Box from "../box/index.js";

import styles from "./styles.module.scss";

const CardHeader = ({ control = null, direction = "ltr", heading = null }) => {
  return (
    <div className={styles.cardHeader} data-direction={direction}>
      <h3>{heading}</h3>
      {control && control}
    </div>
  );
};

CardHeader.propTypes = {
  control: PropTypes.node,
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

const CardMainImage = ({ mainImage = null }) => {
  return mainImage ? (
    <div className={styles.cardMainImage}>{mainImage}</div>
  ) : null;
};

CardMainImage.propTypes = {
  mainImage: PropTypes.node
};

const CardContent = ({ children = null }) => {
  return <div className={styles.cardContent}>{children}</div>;
};

CardContent.propTypes = {
  children: PropTypes.node
};

const CardDateTime = ({ date = null, pinnedPost = false }) => {
  return date ? (
    <span className={styles.cardDateTime}>
      {date && `${pinnedPost ? "Pinned Post" : date}`}
    </span>
  ) : null;
};

CardDateTime.propTypes = {
  date: PropTypes.string,
  pinnedPost: PropTypes.bool
};

const CardDescription = ({ children = null }) => {
  return children ? (
    <span className={styles.cardDescription}>{children}</span>
  ) : null;
};

CardDescription.propTypes = {
  children: PropTypes.string
};

const CardReadMore = ({ link = null, showReadMore = true }) => {
  return (
    showReadMore && link && <div className={styles.cardReadMore}>{link}</div>
  );
};

CardReadMore.propTypes = {
  link: PropTypes.node,
  showReadMore: PropTypes.bool
};

const Card = ({
  background = "none",
  children = null,
  className = null,
  corners = "rounded",
  date = null,
  description = null,
  fadeInUp = false,
  headerProps = {
    control: null,
    direction: "ltr",
    heading: null
  },
  link = null,
  mainImage = null,
  pinnedPost = false,
  profiling = "border",
  showReadMore = true
}) => {
  return (
    <Box
      background={background}
      className={`${styles.card} ${className ? className : ""} ${
        fadeInUp ? styles.cardFadeInUp : ""
      }`}
      corners={corners}
      element="div"
      profiling={profiling}
    >
      <CardMainImage mainImage={mainImage} />
      <CardContent>
        <CardHeader {...headerProps} />
        <CardDateTime date={date} pinnedPost={pinnedPost} />
        <CardDescription>{description}</CardDescription>
        {children && children}
        <CardReadMore link={link} showReadMore={showReadMore} />
      </CardContent>
    </Box>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  corners: PropTypes.oneOf(["rounded", "sharp"]),
  date: PropTypes.string,
  description: PropTypes.string,
  fadeInUp: PropTypes.bool,
  headerProps: PropTypes.shape({
    heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    direction: PropTypes.oneOf(["ltr", "rtl"]),
    control: PropTypes.node
  }),
  link: PropTypes.node,
  mainImage: PropTypes.node,
  pinnedPost: PropTypes.bool,
  profiling: PropTypes.oneOf(["background", "border", "borderless", "shadow"]), // todo: add this
  showReadMore: PropTypes.bool
};

export default Card;
